import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout pageTitle="About Us">
    <SEO title="About" />
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi vel, perspiciatis eum rerum dolor doloribus quam enim non repellendus illum ipsa iste illo ab vitae aliquid ipsum a voluptates. Deserunt cum ipsam eos repellat est?</p>
  </Layout>
)

export default AboutPage
